import { defineStore, acceptHMRUpdate } from 'pinia'

interface SubscriptionTypeCardState {
  // Pinia state for the subscription type card selection panel.

  selectedSubscriptionTypeId: string | null
  // Id of the currently selected subscription type; null when none is selected.
}

export const useSubscriptionTypeCardStore = defineStore('subscriptionTypeCard', {
  state: (): SubscriptionTypeCardState => ({
    selectedSubscriptionTypeId: null,
  }),
  getters: {
    hasSelection: (state): boolean => state.selectedSubscriptionTypeId !== null,
  },
  actions: {
    selectSubscriptionType(id: string): void {
      if (this.selectedSubscriptionTypeId === id) return
      this.selectedSubscriptionTypeId = id
    },
    clearSelection(): void {
      this.selectedSubscriptionTypeId = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSubscriptionTypeCardStore, import.meta.hot))
}
